var React = require('react');
var Painters = require('../_common/Painters');

var PaintersTitrisation = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        backgroundKey: React.PropTypes.string
    },

    getDefaultProps: function() {
        return {
            hideFirstCharacter : true,
            titles: ['aloo'],
            roles: ['aloo_title'],
            texts: [
                {
                    title: 'Aloo Gosh',
                    subtitle: 'Ingénieur\nfinancier',
                    opts: {
                        align: 'right',
                        x: 1010,
                        y: 1060,
                    },
                },
            ],
        };
    },

    render: function() {
        return (
            <Painters {...this.props} />
        );
    }

});

module.exports = PaintersTitrisation;



// WEBPACK FOOTER //
// ./js/components/frames/B-Titrisation/5-Painter.jsx